<div class="fixed left-0 right-0 top-insetTop hero">
  <svg class="wave" viewBox="0 0 1440 80" preserveAspectRatio="none">
    <path d="M0,80 C480,0 960,0 1440,80 L1440,80 L0,80 Z" fill="#ffffff"/>
  </svg>
  <div class="absolute left-1/2 right-1/2 w-[24rem] top-0 bottom-0 -translate-x-1/2">
    <img class="absolute rounded-lg" style="top: 5rem; left: 2rem; width: 7rem; aspect-ratio: 3/2"
         src="/assets/images/housing-lottery/williamsburg-wharf-a1-photo-0.png" alt=""/>
    <img class="absolute rounded-lg" style="top: 11.5rem; left: 5rem; width: 6rem; aspect-ratio: 3/2"
         src="/assets/images/housing-lottery/williamsburg-wharf-a1-photo-5.png" alt=""/>
    <img class="absolute rounded-lg" style="top: 7rem; right: 2.5rem; width: 8rem; aspect-ratio: 3/2"
         src="/assets/images/housing-lottery/williamsburg-wharf-a1-photo-4.png" alt=""/>
  </div>
</div>
<h1 class="mt-[16rem] text-center text-4xl font-semibold">Housing Lottery <br><span class="text-orange-gradient">Made Easy</span></h1>
<p class="text-center mt-8 font-light mb-2">Auto-apply to all NYC Housing Lotteries<br> in just 7 minutes.</p>
@if (user(); as user) {
  <a class="mt-auto" pButton [routerLink]="initialSignupRoute"><span pButtonLabel>{{ user.status === 'unauthorized' ? 'Get started' : 'Continue signing up' }}</span></a>
  @if (user.status === 'unauthorized') {
    <a class="mt-2" pButton severity="secondary" [routerLink]="loginRoute"><span pButtonLabel>Already using Homey? Log in</span></a>
  } @else {
    <p class="text-muted-color text-center mt-2 text-sm">Logged in as {{ user.email }},
      <button class="underline cursor-pointer" (click)="onLogoutClick()">Logout</button>
    </p>
  }
}
